import { useEffect, useRef, useState } from "react";

export default function ProcessPreview() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setVisible(true);},
      { threshold: 0.05 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="prosess" ref={ref} className="bg-secondary/50">
      <div className="grid grid-cols-1 md:grid-cols-2 min-h-[600px] md:min-h-screen">
        <div className={`relative overflow-hidden transition-all duration-700 ${visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-6"}`}>
          <img src="https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/fe94062d3_pexels-cottonbro-7482634.jpg"

          alt="LYKKE badstue prosess"
          className="w-full h-full object-cover"
          loading="lazy" />
          
        </div>

        <div className={`px-8 md:px-16 py-16 md:py-0 flex flex-col justify-center transition-all duration-700 ${visible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-6"}`} style={{ transitionDelay: "80ms" }}>

          <div>
            <p className="text-sm tracking-widest-2xl font-body uppercase text-primary mb-6">
              Prosessen
            </p>
            <h2 className="font-heading text-4xl md:text-5xl font-light leading-[1.1] mb-6">
              Fra forespørsel
              <br />
              <span className="italic">til badstuen din</span>
            </h2>
            <p className="font-body text-2xl leading-relaxed text-foreground/70 mb-8">
              Vi tar deg gjennom hele prosessen fra valg av modell, via design og produksjon, til levering og montering. Alt er planlagt for å gjøre ditt badstueprosjekt enkelt og smertefritt.
            </p>
            <a
              href="/process"
              className="inline-block text-base tracking-widest-xl font-body uppercase px-8 py-3.5 border border-primary text-primary hover:bg-primary hover:text-white transition-all duration-300">
              
              Se hele prosessen
            </a>
          </div>
        </div>
      </div>
    </section>);

}